import './../../shop/modules/multi_checkout/services.multi-checkout';
import { isEmpty } from 'lodash-es';
import '../../shop/modules/services.pnotify';
import '../../shop/modules/services.recaptcha';
import { DESTINATION_TYPES } from './constants/destinationType';
import { CHECKOUT_EVENTS } from '../../shop/constants/angular-events';
import { CART_STEPS } from './constants/multi-checkout';

app.directive('destinationSectionSaveAddress', [
  '$http',
  'mainConfig',
  'pnotifyService',
  '$filter',
  'RecaptchaService',
  'multiCheckoutService',
  function (
    $http,
    mainConfig,
    pnotifyService,
    $filter,
    RecaptchaService,
    multiCheckoutService,
  ) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.save-address.html'),
      scope: {
        address: '=',
        country: '@',
        options: '=',
        disabled: '=',
        userAddresses: '=',
        deliveryOptionIds: '=',
        isLoading: '=',
      },
      link: function (scope) {
        scope.isRecaptchaEnabled = mainConfig.isRecaptchaEnabled;
        scope.state = {
          tempAddress: {},
          addressType: 'saved-address-0',
          defaultAddress: scope.address,
        };
        scope.currentUserDeliveryAddress =
          mainConfig.currentUser.delivery_addresses;

        scope.shouldValidate = () => {
          return (
            scope.state.addressType === 'new' &&
            scope.options.validateBeforeSubmit
          );
        };

        scope.setUserAddress = (userAddress) => {
          scope.address = userAddress;
        };

        scope.removeAddress = (address, index) => {
          scope.isLoading = true;
          const filterUserSavedAddress =
            scope.currentUserDeliveryAddress.filter(
              (addr) => getFullAddress(addr) !== getFullAddress(address),
            );

          $http
            .put(`/api/users/${mainConfig.currentUser._id}`, {
              user: {
                delivery_addresses: filterUserSavedAddress,
              },
              recaptchable: true,
            })
            .then(({ data }) => {
              scope.currentUserDeliveryAddress = data.data.delivery_addresses;
              scope.userAddresses = scope.userAddresses.filter(
                (_, idx) => idx !== index,
              );

              const addressTypeIndex = scope.state.addressType.startsWith(
                'saved-address-',
              )
                ? parseInt(
                    scope.state.addressType.replace('saved-address-', ''),
                    10,
                  )
                : null;

              if (
                addressTypeIndex < index ||
                addressTypeIndex === null ||
                scope.state.addressType === 'new'
              ) {
                return;
              }

              if (scope.userAddresses.length === 0) {
                scope.state.addressType = 'new';
              } else if (addressTypeIndex === index) {
                scope.state.addressType = 'saved-address-0';
              } else {
                scope.state.addressType = `saved-address-${addressTypeIndex - 1}`;
              }
            })
            .catch(() => {
              pnotifyService.notify(
                $filter('translate')('saved_stores.update.failure'),
                {
                  customClass: 'error',
                  icon: 'fa fa-exclamation-triangle',
                },
              );
            })
            .finally(() => {
              scope.isLoading = false;
            });
        };

        scope.removeAddressWithRecaptcha = (address, index) => {
          RecaptchaService.executeWithPromise().then(() =>
            scope.removeAddress(address, index),
          );
        };

        scope.$watch('state.addressType', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }

          if (newVal === 'new') {
            scope.address = scope.state.tempAddress;
            return;
          }

          if (newVal.includes('saved-address-')) {
            scope.options.validateBeforeSubmit = false;
            const addressIndex = parseInt(
              newVal.replace('saved-address-', ''),
              10,
            );
            if (scope.userAddresses[addressIndex]) {
              scope.address = scope.userAddresses[addressIndex];
            }
            return;
          }
        });

        scope.$watch('state.defaultAddress', function (newVal) {
          if (isEmpty(newVal)) {
            scope.address = scope.userAddresses[0] || {};
            return;
          }

          const addressString = getFullAddress(newVal);

          const userAddressIndex = scope.userAddresses.findIndex(
            (userAddress) => {
              const userAddressString = getFullAddress(userAddress);
              return addressString === userAddressString;
            },
          );

          if (userAddressIndex > -1) {
            scope.state.addressType = `saved-address-${userAddressIndex}`;
            scope.address = scope.userAddresses[userAddressIndex];
            return;
          }

          scope.state.addressType = 'new';
          scope.state.tempAddress = newVal;
          scope.address = newVal;
        });

        scope.$on(CHECKOUT_EVENTS.CART.STEP.NEXT, (_, { nextStep }) => {
          if (
            nextStep !== CART_STEPS.DESTINATION ||
            scope.state.addressType === 'new'
          ) {
            return;
          }

          multiCheckoutService.trackFillRecipientData(
            DESTINATION_TYPES.SAVE_ADDRESS,
          );
        });

        function getFullAddress(addressObject) {
          const { country, city, address_1, address_2 } = addressObject;
          return `${country}.${city}.${address_1}.${address_2}`;
        }
      },
    };
  },
]);
